import { render, staticRenderFns } from "./UploadFilesModal.vue?vue&type=template&id=d3639180&scoped=true&"
import script from "./UploadFilesModal.vue?vue&type=script&lang=js&"
export * from "./UploadFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilesModal.vue?vue&type=style&index=0&id=d3639180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3639180",
  null
  
)

export default component.exports